<template>
    <ul class="pagination align-items-center">
        <li class="page-item" title="Previous Page">
            <a class="page-link first"
               v-disabled="currentPage === 1"
               @click.prevent="$emit('select', currentPage-1)"
            >
                <icon name="chevron-left"/>
            </a>
        </li>

        <li v-for="page in pages" :key="page" class="page-item">
            <icon v-if="page === null" name="dots-horizontal" class="px-2"/>
            <a v-else
               class="page-link"
               v-c:active="page === currentPage"
               @click.prevent="$emit('select', page)"
            >{{ page }}</a>
        </li>

        <li class="page-item" title="Next Page">
            <a class="page-link last"
               v-disabled="currentPage === totalPages || totalPages === 0"
               @click.prevent="$emit('select', currentPage + 1)"
            >
                <icon name="chevron-right"/>
            </a>
        </li>
    </ul>
</template>

<script>
    import range from 'lodash/range';

    export default {
        props: {
            currentPage: Number,
            totalPages: Number,
        },

        computed: {
            pages() {
                let cutOff = 2;
                let min = Math.max(1, this.currentPage - cutOff);
                let max = Math.min(this.totalPages, this.currentPage + cutOff);
                let pages =  range(min, max+1);

                if (min > 2) {
                    pages.unshift(null);
                    pages.unshift(1);
                } else if (min === 2) {
                    pages.unshift(1);
                }

                if (max < this.totalPages-1) {
                    pages.push(null);
                    pages.push(this.totalPages);
                } else if (max === this.totalPages-1) {
                    pages.push(this.totalPages);
                }

                return pages;
            },
        },
    };
</script>